import { AfterViewInit, Component, Injectable, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, map } from 'rxjs';
import { environment } from '@environments/environment';
import { CommonModule } from '@angular/common';
const { connect } = require('twilio-video');
import { AgentLiveViewHub } from 'src/app/pages/hubs/tm/AgentLiveViewHub';
import { RemoteParticipant } from 'twilio-video';
let self;
@Component({
    selector: 'app-manager-live-moniter',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './manager-live-moniter.component.html',
    styleUrl: './manager-live-moniter.component.scss',
    encapsulation: ViewEncapsulation.None
})
@Injectable({ providedIn: 'root' })
export class ManagerLiveMoniterComponent implements OnInit, OnDestroy {
    StatusList: any = [
        {
            id: 1,
            label: 'Initializing video stream...',
            iconClass: 'text-warning',
            MsgView: false,
            isTimedOut:true
        },
        {
            id: 2,
            label: 'Preparing UI component..',
            iconClass: 'text-warning',
            MsgView: false, isTimedOut: false
        },
        {
            id: 3,
            label: 'Agent authencation verification done',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: false
        },
        {
            id: 4,
            label: 'Manager authencation verification failed.. Please retry..',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: false
        },
        {
            id: 5,
            label: 'Setup manager video Configurations',
            iconClass: 'text-warning',
            MsgView: false, isTimedOut: false
        },
        {
            id: 6,
            label: 'Connect to the Room',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: false
        },
        {
            id: 7,
            label: 'Keeping a close eye on your agents activities at work.',
            iconClass: 'text-success',
            MsgView: false, isTimedOut: false
        },
        {
            id: 8,
            label: 'Agent window Disconnected...',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: false
        },
        {
            id: 9,
            label: 'Please wait your video steaming is proccessing...',
            iconClass: 'text-success',
            MsgView: false, isTimedOut: false
        },
        {
            id: 10,
            label: 'Agent is reconnecting to the Room',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: false
        },
        {
            id: 11,
            label: 'Ready your video steaming',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: false
        },
        {
            id: 12,
            label: 'Agent is reconnecting failed',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: true
        },
        {
            id: 13,
            label: 'we are tried maximum reconnect attempt. Please reconnect again',
            iconClass: 'text-danger',
            MsgView: false, isTimedOut: true
        },
        {
            id: 14,
            label: 'Please wait still agent not connected.',
            iconClass: 'text-info',
            MsgView: false, isTimedOut: false
        },
    ]
    authToken: any;
    StatusDetail: any;
    AgentName: any;
    AgentId: any;
    debugMode: any = true;
    managerId: any;
    UserRoom: string;
    managerRoom: string;
    clientName: string;
    managerAPI: any;
    activeRoom: any;
    agentLiveViewer: HTMLElement | null;
    waitingForAgent: any;
    agentRetries: any;
    agentMaxRetries: any = 3;
    agentTimeout: any = 60000;
    public timerInterval: any;
    display: any; 
    constructor(public bsModalRef: BsModalRef,
        private AgentViewHub: AgentLiveViewHub) {
    }
    ngOnInit(): void { 
        this.updateStatus(1);
        self = this;
        this.debugMode = (environment.environmentName !== 'PROD');
        this.debug('AgentName', this.AgentName);
        this.debug('AgentId', this.AgentId);
        this.debug('managerId', this.managerId);
        this.UserRoom = this.clientName + "-agentLiveView-" + this.managerId + "-" + this.AgentId + "-" + (new Date().getTime());
        this.managerRoom = this.clientName + "-manager-" + this.managerId + "-" + (new Date().getTime());
        this.debug(this.UserRoom, this.managerRoom);
        this.getToken({ callback: this.joinTwilioRoom });
    }

    SetWindowSize(size: any) {
        this.bsModalRef.setClass(size);
    }
    closeModal() {
        this.leaveTwilioRoom();
        this.AgentViewHub.callServerMethod("agentLiveView", [this.UserRoom, this.AgentId, 'disconnect', this.debugMode]);
        this.bsModalRef.hide();
    }

    ngOnDestroy() {
        this.closeModal();
        this.agentTimeout && clearTimeout(this.agentTimeout);
    }
    debug(msg: string, obj?: any) {
        if (this.debugMode) {
            if (!this.isEmptyObject(obj))
                console.log(msg, obj);
            else
                console.log(msg);
        }
    }
    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }
    toPascalCase = (str) => {
        let tempArray = str.split(" ");
        tempArray = tempArray.map(
            (value) => value.charAt(0).toUpperCase() + value.slice(1, value.length)
        );
        return tempArray.join(" ");
    };

    ngAfterViewInit() {
        this.updateStatus(2);
        this.agentLiveViewer = document.getElementById('agentLiveViewer') as HTMLElement;
    }

    getToken(customData: any) {
        this.managerAPI.GetVideoToken(this.managerRoom, null)
            .pipe(map((data: any) => {
                this.authToken = data.Response.Data;
                this.debug(this.authToken, data.Response.Data);
                self.updateStatus(3);
                if (customData.hasOwnProperty('callback')) {
                    customData.callback(data.Response.Data);
                }
            }),
                catchError(error => {
                    console.log(error);
                    self.updateStatus(4);
                    return EMPTY;
                })
            ).subscribe();
    }

    joinTwilioRoom(token: any) {
        self.updateStatus(5);
        connect(token, { name: self.UserRoom, audio: false, video: false }).then(function (room) {
            self.activeRoom = room;
            if (self.debugMode) console.log('LiveView - Joined Room: ' + self.managerRoom);
            self.updateStatus(6);
            self.HandleEvents(room);
        });

    }
    HandleEvents(room: any) {
        room.on('participantConnected', function (participant) {
            if (self.debugMode) console.log('LiveView - Joined Room: ' + participant.identity);
            self.updateStatus(7);
            this.waitingForAgent = false;
            clearInterval(this.agentTimeout);
            clearInterval(this.timerInterval);
            participant.tracks.forEach(publication => {
                self.trackPublished(publication, participant);
            }); 
        });

        room.on('participantDisconnected', function (participant) {
            if (self.debugMode) console.log('LiveView - Left Room: ' + participant.identity);

            participant.tracks.forEach(publication => {
                if (publication.track)
                    self.detachTrack(publication.track, participant);
            });

            self.updateStatus(8);
            //reconnectAgent(true); 
            this.isErrMessage = true;
            this.isMicDisabled = !this.isErrMessage;

        });
        room.on('participantReconnecting', participant => {
            console.log(participant.identity + ' is reconnecting to the Room');
            self.updateStatus(10, false);
            self.reconnectAgent(true);
        });

        room.on('participantReconnected', participant => {
            console.log(participant.identity + ' reconnected to the Room');
            self.updateStatus(11, false);
        });
        room.on('trackPublished', function (publication, participant) {
            self.trackPublished(publication, participant);
        });

        room.on('trackUnpublished', function (publication, participant) {
            if (publication.track)
                self.detachTrack(publication.track, participant);
        });

        room.on('disconnected', function (room, error) {
            if (error) {
                console.log('LiveView - Disconnect Error: ' + error);
                //cls.dispatchEvent(im.AgentLiveView.DISCONNECT_ERROR);
                room.disconnect();
                self.leaveTwilioRoom();
            }
            if (self.debugMode) console.log('LiveView - Left Room: ' + this.UserRoom);
        });
        room.on('reconnecting', error => {
            console.log('Live Moniter', error);
            if (error.code === 53001) {
                console.log('Reconnecting your signaling connection!', error.message);
            } else if (error.code === 53405) {
                console.log('Reconnecting your media connection!', error.message);
            }
            self.updateStatus(11, false);
            self.reconnectAgent(true);
        });
        this.waitingForAgent = true;
        
        self.AgentViewHub.callServerMethod("agentLiveView", [self.UserRoom, self.AgentId, 'connect', true]);
        self.updateStatus(9);
        
        self.updateStatus(14);
        this.start(1);
    }
    trackPublished = function (publication, participant) {
        if (publication.isSubscribed) {
            self.attachTrack(publication.track, participant);
        }

        publication.on('subscribed', track => {
            self.attachTrack(track, participant);
        });

        publication.on('unsubscribed', track => {
            self.detachTrack(track, participant);
        });
    }
    attachTrack = function (track, participant) {
        clearInterval(this.timerInterval);
        if (this.debugMode) console.log('LiveView - Track Added(' + track.kind + '): ' + participant.identity);
        this.agentLiveViewer.appendChild(track.attach());
        if (track.kind == 'video') { 
            self.updateStatus(null, true);
            var video = this.agentLiveViewer.querySelector('video'); 
        } 
    }

    leaveTwilioRoom = function () {
        if (this.activeRoom?.state == 'connected')
            this.activeRoom.disconnect();
        this.isErrMessage = false;
        this.isMicDisabled = !this.isErrMessage;
    }
    detachTrack(track, participant) {
        if (this.debugMode) console.log('LiveView - Track Removed(' + track.kind + '): ' + participant.identity);
        track.detach().forEach(element => element.remove());
    }
    updateStatus(StatusId: any, isHide?: boolean) {
        if (StatusId > 0) {
            this.StatusDetail = this.StatusList.filter((person) => person.id == StatusId)[0];
            console.log(this.StatusDetail);
        }
        if (isHide != null) this.StatusDetail.MsgView = isHide;
    }
    reconnectAgent(initial) {
        clearInterval(this.agentTimeout);
        if (initial) {
            this.waitingForAgent = true;
            this.agentRetries = 0; 
        }
        if (this.waitingForAgent) {
            if (this.agentRetries >= this.agentMaxRetries) {
                this.updateStatus(13, false);
                this.waitingForAgent = false;
                this.closeModal();
            } else {
                console.log(new Date(), this.agentRetries);
                this.agentRetries++;
                this.updateStatus(12, false);
                this.AgentViewHub.callServerMethod("agentLiveView", [this.UserRoom, this.AgentId, 'connect', this.debugMode]);
                this.agentTimeout = setTimeout(() => { this.reconnectAgent(false); }
                    , this.agentTimeout);
            }
        }
    }
    start(minute) {
        this.timer(minute);
        //this.StatusDetail.isTimedOut = true;
    } 

    timer(minute) { 
        let seconds: number = minute * 60;
        let textSec: any = '0';
        let statSec: number = 60;

        const prefix = minute < 10 ? '0' : '';

        this.timerInterval = setInterval(() => {
            seconds--;
            if (statSec != 0) statSec--;
            else statSec = 59;

            if (statSec < 10) {
                textSec = '0' + statSec;
            } else textSec = statSec;

            this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
           // this.StatusDetail.isTimedOut = Math.floor(seconds / 60) < 3 ? true : false;
            if (seconds == 0) {
                console.log('finished');
                clearInterval(this.timerInterval);
               // this.StatusDetail.isTimedOut = false;
                this.reconnectAgent(true);
               // this.isTimedOut = false;
            }
        }, 1000);
    }
}


